import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";

/* eslint-disable flowtype/require-valid-file-annotation */

/* eslint-disable prefer-rest-params */

/**
 * Simple configuration bag.
 *
 * Simply access and organize your configuration.
 */
import tail from 'lodash/tail';
import first from 'lodash/first';
import isArray from 'lodash/isArray';
import map from 'lodash/map';
import isUndefined from 'lodash/isUndefined';
import isString from 'lodash/isString';
import isNull from 'lodash/isNull';
import mergeWith from 'lodash/mergeWith';
import reduce from 'lodash/reduce';
import isPlainObject from 'lodash/isPlainObject';
import toArray from 'lodash/toArray';
import merge from 'lodash/merge';
var messages = {
  invalid_src: 'Invalid source object.'
};
/**
 * if first argument is an Array, then `method` will be mapped
 * on every item.
 *
 * Note that extra parameters will be preserved.
 *
 * ``` js
 * function doSomething(value) { ... };
 * let doBetter = utils.scalarOrArray(doSomething);
 *
 * doBetter(['a', 'b'], extra); // calls `doSomething('a', extra)` and
 *                              // then `doSomething('b', extra)`
 * doBetter('a', extra);        // calls `doSomething('a', extra)`
 * ```
 */

function scalarOrArray(method) {
  return function wrappedScalarOrArray() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var extra = tail(args);
    var arg = first(args);

    if (isArray(arg)) {
      return map(arg, function (_arg) {
        return method.apply(_this, [_arg].concat(extra));
      });
    }

    return method.apply(this, args);
  };
}
/**
 * add the ability to a function to accept object instead of
 * `key`, `value` arguments.
 * Original funciton will be called as many time as the object length.
 *
 * Note that extra parameters will be preserved.
 *
 * ``` js
 * function doSomething(key, value) { ... };
 * let doBetter = utils.keyValueOrObject(doSomething);
 *
 * // calls `doSomething('a', 'foo', extra)`
 * // and then `doSomething('b', 'bar', extra)`
 * doBetter({a:'foo', b: 'bar'}, extra);
 *
 * // calls `doSomething('a', 'foo', extra)`
 * doBetter('a', 'foo', extra);
 * ```
 */


function keyValueOrObject(method) {
  return function wrappedKeyValueOrObject(key
  /* , value */
  ) {
    var _this2 = this;

    var extra;

    if (!isString(key)) {
      extra = tail(arguments, 1);
      return map(key, function (_value, _key) {
        return method.apply(_this2, [_key, _value].concat(extra));
      });
    }

    extra = tail(arguments, 2);
    return method.apply(this, arguments);
  };
}
/**
 * deeply read a property.
 *
 * ``` js
 * let o = {a: {b: {c: 'foo'}}};
 * getProperty('a.b.c', o);             // returns 'foo'
 * getProperty('a.b.d', o, 'default');  // returns 'default' as `b` has no
 *                                      // `d` property.
 * ```
 *
 * This method is already decorated with `scalarOrArray`, that makes
 * it possible to call directly with an array of arguments:
 *
 * ``` js
 * let o = {a: {b: {c: 'foo'}}};
 * getProperty(['a.b.c', 'a.b.d'], o, 'default'); // returns ['foo', 'default']
 * ```
 * */


var getProperty = scalarOrArray(function (key, from, alt) {
  // never return undefined, always null
  var defaultValue = isUndefined(alt) ? null : alt;
  var keys = key.split('.');
  var result = reduce(keys, function (accumulator, property) {
    if (accumulator && property in accumulator) {
      return accumulator[property];
    }

    return null;
  }, from);
  return isNull(result) || isUndefined(result) ? defaultValue : result;
});
/**
 * deeply set a property.
 *
 * In case task is impossible, then an error is thrown.
 *
 * ``` js
 * let o = {a: {b: {c: 'foo'}}};
 * setProperty('a.b.c', 'bar', o);
 * setProperty('d.e.f', 'baz', o);
 * ```
 *
 * This method is already decorated with `keyValueOrObject`, that makes
 * it possible to call directly with an object:
 *
 * ``` js
 * let o = {a: {b: {c: 'foo'}}};
 * setProperty({
 *     'a.b.c': 'bar',
 *     'd.e.f', 'baz'
 * }, o);
 * ```
 */

var setProperty = keyValueOrObject(function (key, value, to) {
  var keys = key.split('.');
  var prop = keys.pop();
  var result = reduce(keys, function (accumulator, property) {
    if (!(accumulator instanceof Object)) {
      throw new Error(messages.invalid_src);
    }

    if (property in accumulator && isPlainObject(accumulator[property])) {
      return accumulator[property];
    } // create the property as an object


    accumulator[property] = {};
    return accumulator[property];
  }, to);

  if (prop) {
    result[prop] = value;
  }
});
/**
 * Custom merge function to fit all of our cases.
 */

function customMerge(oldVal, newVal) {
  if (isArray(newVal) && isArray(oldVal)) {
    return oldVal.concat(newVal);
  }

  if (isPlainObject(newVal) && isPlainObject(oldVal)) {
    return merge(oldVal, newVal, customMerge);
  }

  return newVal;
}

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);

    this.state = {};
  }
  /**
   * Recusrsively read a deep property.
   *
   * If property is undefined, then reutnr the default  value.
   *
   * @return Mixed
   */


  _createClass(Config, [{
    key: "get",
    value: function get(path, defaultValue) {
      if (!path || path === '') {
        return this.state;
      }

      return getProperty(path, this.state, defaultValue);
    }
    /**
     * override new property in current state.
     *
     * Use it to extend/override current configuration.
     *
     * @return Config
     */

  }, {
    key: "set",
    value: function
      /* key, value */
    set() {
      var args = toArray(arguments);
      args = args.concat([this.state]);
      setProperty.apply(void 0, _toConsumableArray(args));
      return this;
    }
    /**
     * merge new properties to current state.
     *
     * Use it to extend/override current configuration.
     *
     * @return Config
     */

  }, {
    key: "merge",
    value: function merge() {
      this.state = mergeWith.apply(void 0, [{}, this.state].concat(Array.prototype.slice.call(arguments), [customMerge]));
      return this;
    }
    /**
     * serialize configuration.
     *
     * Not sure it will be needed though, but for now (june 2015) this is the way
     * it works.
     *
     * @return String
     */

  }, {
    key: "serialize",
    value: function serialize() {
      return _JSON$stringify(this.state);
    }
  }, {
    key: "freeze",
    value: function freeze() {
      var _this3 = this;

      ['set', 'merge'].forEach(function (prop) {
        _this3[prop] = function () {
          throw new Error("Configuration is freezed, you cannot call ".concat(prop, " anymore"));
        };
      });
    }
  }]);

  return Config;
}();
/**
 * load configuration from a string.
 *
 * This is highly unstable, current behavior is merging state, but it makes
 * sense to replace the whole configuration.
 */


Config.deserialize = function deserialize(state) {
  var config = new Config();
  return config.merge(JSON.parse(state));
};

export default Config;